<template>
  <aviso-bloqueio v-if="empresa && (!empresa.ativo || empresa.tipo_empresa !== 3)"/>
  <v-layout align-space-around justify-start fill-height column class="pt-5" v-else>
    <v-toolbar
      color="transparent"
      class="elevation-0 secondary--text"
      style="background: transparent">
      <v-toolbar-title>Empresas Integradas</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn v-on="on" small fab color="info" @click="showFilter = !showFilter">
            <v-icon>{{ !showFilter ? 'filter_list' : 'filter_list_off' }}</v-icon>
          </v-btn>
        </template>
        <span>{{!showFilter ? 'Mostrar filtros' : 'Recolher filtros'}}</span>
      </v-tooltip>
    </v-toolbar>
    <v-slide-x-transition>
      <v-card v-show="showFilter" class="ml-4 mr-4">
        <v-card-text>
          <v-layout wrap justify-space-between>
            <v-flex xs10 md11>
              <v-layout wrap justify-space-around>
                <v-flex xs11 sm5 md3 lg2 xl2>
                  <v-text-field
                    label="CNPJ"
                    v-model="cnpj_empresa"
                  ></v-text-field>
                </v-flex>
                <v-flex xs11 sm5 md3 lg2 xl2>
                  <v-text-field
                    label="Nome fantasia"
                    v-model="nome_fantasia"
                  ></v-text-field>
                </v-flex>
                <v-flex xs11 sm5 md3 lg2 xl2>
                  <v-text-field
                    label="Cidade"
                    v-model="cidade"
                  ></v-text-field>
                </v-flex>
                <v-flex xs11 sm5 md1 lg2 xl2>
                  <v-select
                    label="Estado"
                    v-model="estado"
                    :items="estados"
                  />
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs2 md1 align-self-center>
              <v-btn fab small color="info" @click="carregarEmpresas(true)">
                <v-icon>search</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-slide-x-transition>
      <v-data-table
        hide-default-footer
        :headers="empresaHeaders"
        :items="empresas"
        :options.sync="pagination"
        no-data-text="Você ainda não possui empresas cadastrados"
        class="elevation-1"
      >
        <template v-slot:item="props">
          <tr>
            <td><v-icon color="info">local_gas_station</v-icon></td>
            <td>{{ props.item.cnpj }}</td>
            <td>{{ props.item.nome_fantasia }}</td>
            <td>{{ props.item.endereco ? props.item.endereco.cidade : '' }}{{props.item.endereco ? `/${props.item.endereco.estado}` : ''}}</td>
            <td class="text-xs-right">
              <v-layout row>
                <v-tooltip left>
                  <template v-slot:activator="{ on }">
                    <div v-on="on">
                      <requisicoes :empresa_integrada="props.item"/>
                    </div>
                  </template>
                  <span>Gerenciar Requisições</span>
                </v-tooltip>
                <v-tooltip left>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      v-on="on"
                      icon
                      color="primary"
                      @click="
                        dialogVisualizar = true,
                        empresaSelecionada = props.item
                      "
                    >
                        <v-icon>visibility</v-icon>
                    </v-btn>
                  </template>
                  <span>Visualizar dados do posto</span>
                </v-tooltip>
              </v-layout>
            </td>
          </tr>
        </template>
      </v-data-table>
    <div class="text-xs-center">
      <v-pagination v-model="pagination.page" :length="pages" circle></v-pagination>
    </div>
    <v-dialog v-model="dialogVisualizar" v-if="dialogVisualizar" scrollable width="650">
      <visualizar-empresa-integrada
        :empresa="empresaSelecionada"
        @fechar="dialogVisualizar = false, empresaSelecionada = undefined"
      />
    </v-dialog>
  </v-layout>
</template>
<script>
import VisualizarEmpresaIntegrada from '@/components/dialogs/VisualizarEmpresaIntegrada'
import AvisoBloqueio from '@/components/AvisoBloqueio'
import Requisicoes from '@/components/dialogs/Requisicoes.vue'
export default {
  components: { VisualizarEmpresaIntegrada, AvisoBloqueio, Requisicoes },
  data () {
    return {
      dialogVisualizar: false,
      empresas: [],
      empresaSelecionada: undefined,
      totalItens: 0,
      cnpj_empresa: undefined,
      nome_fantasia: undefined,
      cidade: undefined,
      estado: undefined,
      showFilter: false,
      pagination: {
        page: 1,
        rowsPerPage: 5
      },
      empresaHeaders: [
        {
          align: 'right',
          sortable: false
        },
        {
          text: 'CNPJ',
          value: 'cnpj',
          sortable: false,
          align: 'left'
        },
        {
          text: 'Nome',
          align: 'left',
          sortable: false,
          value: 'nome_fantasia'
        },
        {
          text: 'Local',
          value: 'estado.cidade',
          sortable: false,
          align: 'left'
        },
        {
          align: 'right',
          sortable: false
        }
      ]
    }
  },
  watch: {
    pagination: {
      handler (val, oldval) {
        if (this.empresa) this.carregarEmpresas(false)
      },
      deep: true
    },
    empresa (val) {
      if (val !== undefined && val !== null) {
        this.carregarEmpresas(false)
      }
    },
    showFilter (val) {
      if (!val) {
        this.cnpj_empresa = undefined
        this.cidade = undefined
        this.estado = undefined
        this.nome_fantasia = undefined
      }
    }
  },
  computed: {
    pages () {
      const count = this.totalItens
      if (this.pagination.rowsPerPage == null || count == null) return 0

      return Math.ceil(count / this.pagination.rowsPerPage)
    },
    estados () {
      return this.$store.getters.estados
    },
    empresa () {
      return this.$store.getters.empresa
    }
  },
  beforeMount () {
    if (this.empresa) {
      this.carregarEmpresas(false)
    }
  },
  methods: {
    carregarEmpresas (isBtn) {
      const data = {
        cnpj_empresa: this.empresa.cnpj,
        automacao: this.empresa.cnpj
      }
      data.page = isBtn ? 1 : this.pagination.page
      data.page_size = this.pagination.rowsPerPage
      if (this.cnpj_empresa) data.cnpj = this.cnpj_empresa
      if (this.nome_fantasia) data.nome_fantasia__iexact = this.nome_fantasia
      if (this.cidade) data.endereco__cidade__icontains = this.cidade
      if (this.estado) data.endereco__estado__iexact = this.estado
      this.$store.dispatch('pegarEmpresasAtivas', data).then(json => {
        this.empresas = json.results
        this.totalItens = json.count
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
